import { render, staticRenderFns } from "./SalesUnitList.vue?vue&type=template&id=2b0708e5"
import script from "./SalesUnitList.vue?vue&type=script&lang=js"
export * from "./SalesUnitList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports